import TermsGate from './component';

export default TermsGate;
